import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CapAlertType } from './cap-alert.enum';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-bsg-alert',
  template: `
    <div
      class="alert fade alert-{{ type.toString().toLowerCase() }}"
      [class.alert-dismissible]="dismissible"
      [class.show]="!fading"
      role="alert"
    >
      @if (dismissible) {
        <button
          type="button"
          class="btn-close"
          [attr.aria-label]="'Close' | translate"
          (click)="fading = true; dismiss.emit()"
        >
        </button>
      }
      <span class="fas {{ icons[type] }} me-2"></span>
      <ng-content></ng-content>
    </div>
  `,
  imports: [TranslatePipe]
})
export class CapAlertComponent {
  @Input()
  type: CapAlertType;

  @Output()
  dismiss = new EventEmitter<void>();

  get dismissible() {
    return this.dismiss.observers.length;
  }

  fading = false;

  icons = {
    [CapAlertType.DANGER]: 'fa-exclamation-circle',
    [CapAlertType.WARNING]: 'fa-exclamation-triangle',
    [CapAlertType.INFO]: 'fa-info-circle',
    [CapAlertType.SUCCESS]: 'fa-check-circle'
  };
}
